export default {
  state: {
    token: null,
  },
  mutations: {
    clearToken(state) {
      localStorage.removeItem("sh_wiz_token");
      state.token = null;
    },
    updateToken(state, token) {
      state.token = token;
    },
  },
  getters: {
    token(state) {
      return state.token;
    },
  },
  actions: {
    setToken(context, token) {
      context.commit("updateToken", token);
    },
    clearToken(context) {
      context.commit("clearToken");
    },
    async tryAuth(context, { username, password }) {
      const body = JSON.stringify({ login: username, password: password });
      const req = new Request(`${context.getters.url}/api/v1/auth`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: body,
      });
      const response = await fetch(req);
      if (response.status == 200) {
        response.json().then((parsed) => {
          const token = parsed["token"];
          localStorage.setItem("sh_wiz_token", token);
          context.commit("updateToken", token);
        });
      } else if (response.status == 403) {
        throw new Error("У вас нет прав для использования данного сервиса");
      } else if (response.status == 401) {
        throw new Error("Неправильные логин или пароль");
      } else if (response.status == 421) {
        throw new Error("Оишбка подключения к сереверу лицензий");
      }
    },
    async tryLocalAuth(context) {
      const token = localStorage.getItem("sh_wiz_token");
      if (token != null) {
        const headers = new Headers();
        headers.append("Authorization", "Bearer " + token);
        const req = new Request(`${context.getters.url}/api/v1/auth`, {
          method: "GET",
          headers: headers,
        });
        let res = await fetch(req);
        if (res.status == 200) {
          context.commit("updateToken", token);
        } else {
          context.commit("clearToken");
          throw new Error("Токен недействителен");
        }
      }
    },
  },
};
